import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  fill: "#F2F5F7",
  rx: "12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#032E5A",
  d: "M16.754 15.723a.747.747 0 0 1 0 1.058.75.75 0 0 1-1.06 0L12 13.071 8.28 16.78a.75.75 0 0 1-1.06 0 .747.747 0 0 1 0-1.058l3.72-3.708L7.22 8.277a.747.747 0 0 1 0-1.058.75.75 0 0 1 1.06 0L12 10.957l3.72-3.709a.75.75 0 0 1 1.06 0 .747.747 0 0 1 0 1.058l-3.72 3.708z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }